// extracted by mini-css-extract-plugin
export default {"select":"_navbar_select__iNxYd","search":"_navbar_search__MNTO9"};